/**
 * VALORES PROTEGIDOS — o que a revisão IA nunca altera sozinha.
 *
 * TAG, espessura, pressão, temperatura, PMTA, vida remanescente, taxa de
 * corrosão, diâmetro, schedule, datas, normas, revisões, número de
 * relatório, certificados, OS e Sub-OS: tudo isso aparece no texto como
 * NÚMERO ou como IDENTIFICADOR (letras + dígitos + separadores). Extrair os
 * dois e exigir que a sugestão os preserve na mesma quantidade e ordem é a
 * garantia — vale para as regras locais e para qualquer provedor futuro.
 */

/** Números como escritos (6,35 · 6.35 · 1.234,5 · 10 · 2026-09-27 · 18"). */
const NUMBER = /\d+(?:[.,]\d+)*(?:"|'')?/g;

/**
 * Identificadores: sequências com dígito e pelo menos uma letra ou
 * separador técnico — TAG (18"-6000-HC-022-BA, TQ-001), norma (API 570,
 * N-2371, B31.3), OS (OS-2026-014), certificado (CERT-1234), Sub-OS…
 */
const IDENTIFIER = /[A-Za-z0-9"]+(?:[-/.][A-Za-z0-9"]+)+|[A-Za-z]+\d[A-Za-z0-9]*|\d+[A-Za-z]+[A-Za-z0-9]*/g;

/** Siglas de norma e de referência que não podem mudar de grafia. */
const NORM_WORDS = /\b(?:API|ASME|NR|ABNT|NBR|ASTM|ISO|AWS|PETROBRAS|N)\s?-?\s?\d[\w.]*/g;

export function protectedTokens(text: string): string[] {
  const tokens: string[] = [];
  for (const re of [NORM_WORDS, IDENTIFIER, NUMBER]) {
    for (const m of text.matchAll(re)) tokens.push(m[0]);
  }
  return tokens.sort();
}

/** A sugestão preserva exatamente os mesmos valores protegidos que o original? */
export function preservesProtectedTokens(before: string, after: string): boolean {
  const a = protectedTokens(before);
  const b = protectedTokens(after);
  return a.length === b.length && a.every((t, i) => t === b[i]);
}
